<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="推荐人姓名"
            prop="userId"
          >
            <el-select
              class="select"
              v-model="form.userId"
              filterable
              remote
              placeholder="请输入推荐人姓名"
              :remote-method="searchUser"
              @change="checkItem"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="推荐人电话"
            prop="userMobile"
          >
            <el-input
              class="search-input"
              v-model="form.userMobile"
              clearable
              placeholder="请输入推荐人电话"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="注册时间"
            :label-width="formLabelWidth"
            prop="appointmentTime"
          >
            <el-date-picker
              v-model="registerTime"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item class="btn">
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <PermissionsBtn
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/PmcStatisticst/downLoad'"
              :checkList="checkList"
              :form="exportForm"
            ></PermissionsBtn>
            <!-- <el-button
              size="small"
              type="success"
              @click="isExpend = !isExpend"
              >{{ !isExpend ? '展开' : '收起' }}</el-button
            > -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { decrypt, encrypt } from '@/utils/encryp';
export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      // 表单内容
      form: {
        userId: '',
        userMobile: '',
        creationStartTime: '',
        creationEndTime: '',
      },
      registerTime: [],
      exportForm: {
        userId: '',
        userMobile: '',
        creationStartTime: '',
        creationEndTime: '',
      },
      loading: false,
      userList: [],
      selectedOptions: [],
      isExpend: false,
    };
  },
  computed: {
    ...mapGetters(['pickerOptions']),
  },
  watch: {},
  created() {},
  methods: {
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.userList = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选项
    checkItem(val) {
      this.form.userId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      this.$emit('search', {
        ...this.form,
        userMobile: this.form.userMobile ? encrypt(this.form.userMobile) : '',
        creationStartTime: (this.registerTime && this.registerTime[0]) || '',
        creationEndTime: (this.registerTime && this.registerTime[1]) || '',
      });
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm() {
      // this.selectedOptions = [];
      this.registerTime = [];
      this.$refs['form'].resetFields();
      this.form = {
        userId: '',
        userMobile: '',
        creationStartTime: '',
        creationEndTime: '',
      };
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.search-select1 {
  // width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
